import { experiences } from "../content/experience";
import { CaseStudyCard, ExperienceCta } from "../components/CaseStudyCard";

export function ExperiencePage() {
  return (
    <section>
      <div className="page-intro page-intro--compact">
        <p className="eyebrow">Experience</p>
        <h1 className="section-title">Selected work</h1>
        <p className="lead muted">
          Selected engagements in hardware, consumer software, and marketplaces.
          Client names left out.
        </p>
      </div>

      <nav className="case-index" aria-label="Case studies">
        {experiences.map((item) => (
          <a key={item.id} href={`#${item.id}`} className="case-index-link">
            {item.industry}
          </a>
        ))}
      </nav>

      <div className="case-study-list">
        {experiences.map((item) => (
          <CaseStudyCard key={item.id} item={item} />
        ))}
      </div>

      <ExperienceCta />
    </section>
  );
}
